import React from 'react';
import Asset from './asset';
import styles from './project-single.module.scss';
import theme from '../styles/theme.module.scss';

import PortableText from '@sanity/block-content-to-react';
import serializers from './serializers';

function ProjectIntro(props) {
  const url = props.websiteUrl
    ? props.websiteUrl.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').split('/')[0]
    : '';

  const hero = props.heroImage[0];

  const gds = hero.grid ? `gds${hero.grid.gridStart}` : `gds0`;
  const gde = hero.grid ? `gde${hero.grid.gridEnd}` : `gde13`;
  const gms = hero.gridMobile ? `gms${hero.gridMobile.gridStart}` : `gms0`;
  const gme = hero.gridMobile ? `gme${hero.gridMobile.gridEnd}` : `gme5`;
  const maxWidth = (gde - gds) * 160;
  const overlay = `overlay_${hero.overlay}`;
  const heroBgColor = props.heroBgColor ? props.heroBgColor.hex : 'inherit';
  const assetType = hero.asset[0].imageDesktop ? 'assetimage' : 'assetvimeo';

  const introBgColor = props.introBgColor ? props.introBgColor.hex : 'inherit';
  const introTextColor = props.introTextColor ? props.introTextColor.hex : 'inherit';

  const imageDeskFull =
    assetType == 'assetimage' && gds == 'gds0' && gde == 'gde13' ? 'imageDeskFull' : '';
  const imageMobFull =
    assetType == 'assetimage' && gms == 'gms0' && gme == 'gme5' ? 'imageMobFull' : '';

  const videoDeskFull =
    assetType == 'assetvimeo' && gds == 'gds0' && gde == 'gde13' ? 'videoDeskFull' : '';
  const videoMobFull =
    assetType == 'assetvimeo' && gms == 'gms0' && gme == 'gme5' ? 'videoMobFull' : '';
  return (
    <div className={`${styles.intro} ${theme.gdcont} ${theme.gmcont}`}>
      <div
        className={[
          styles.heroAsset,
          theme.gdfull,
          theme.gmfull,
          theme.gdcont,
          theme.gmcont,
          hero.overlay && styles.overlay_desktop_intro_bg,
        ].join(' ')}
        style={{ backgroundColor: `${heroBgColor}` }}>
        <div
          className={[
            styles.heroImage,
            styles[assetType],
            styles[imageDeskFull],
            styles[imageMobFull],
            styles[videoDeskFull],
            styles[videoMobFull],
            theme[gds],
            theme[gde],
            theme[gms],
            theme[gme],
          ].join(' ')}>
          <div className={[styles.heroAssetWrapper, styles[overlay]].join(' ')}>
            <Asset
              asset={hero.asset[0]}
              maxWidth={maxWidth}
              videoDeskFull={videoDeskFull}
              videoMobFull={videoMobFull}
            />
          </div>
        </div>
      </div>

      <div
        className={`${theme.gdfull} ${theme.gdcont} ${theme.gmfull} ${theme.gmcont} ${theme.pT6} ${theme.pB4}`}
        style={{
          backgroundColor: `${introBgColor}`,
          color: `${introTextColor}`,
        }}>
        <div className={`${styles.info} ${theme.mB3} ${theme.gds1} ${theme.gde7} ${theme.gmmain}`}>
          <h1 className={`${theme.h3_founders} ${theme.mB8}`}>{props.title}</h1>
          <PortableText
            className={`${theme.portableText} ${theme.h3_tiempos}`}
            renderContainerOnSingleChild={true}
            blocks={props._rawEntryCopyPortable}
            serializers={serializers}
          />
        </div>
        <ul
          className={`${styles.project_cat} ${theme.gds11} ${theme.gde12} ${theme.gmmain} ${theme.mB8}`}>
          {props.tags && (
            <>
              {props.tags.map(function(cat, index) {
                return <li key={index}>{cat.value}</li>;
              })}
            </>
          )}
          {props.tags.length == 0 && (
            <>
              {props.categories.map(function(cat, index) {
                return <li key={index}>{cat.title}</li>;
              })}
            </>
          )}
        </ul>

        {url.length > 0 && (
          <>
            <div
              className={`${styles.link} ${theme.gds1} ${theme.gdsp3} ${theme.gmmain} ${theme.mB12}`}>
              <a href={props.websiteUrl}>{url}</a>
            </div>
          </>
        )}

        {props.featured.length > 0 && (
          <>
            <div className={`${styles.featured} ${theme.gds1} ${theme.gdsp4} ${theme.gmmain}`}>
              <span>Featured in:</span>
              {props.featured.map(function(cat, index) {
                return (
                  <a href={cat.url} key={index}>
                    {cat.title}
                  </a>
                );
              })}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default ProjectIntro;
